module.exports = __webpack_public_path__ + "img/kefu1.66f01a05.png";